export const GET_FINES = 'GET_FINES';
export const GET_INFO = 'GET_INFO';
export const GET_OPTION = 'GET_OPTION'